// components/Header/index.js

'use client'
import { Flex } from 'antd';
import Logo from './logo';
import SearchBar from './searchBar';
import HeaderBar from './headerBar';
import TopNav from './topNav.js';
import { useData } from '@/context/hooks/DataProvider'
import { usePathname } from 'next/navigation';
import './header.scss';
import { useEffect, useState } from 'react';
import { throttle } from '@/lib/utils';

export default function Header() {
    const [showSearchBar, setShowSearchBar] = useState(false);

    const { user, isLoading, login } = useData();
    const pathname = usePathname();

    useEffect(() => {
        let throttledHandleScroll;
        let checkElementExist;

        if (pathname === '/') {
            const handleScroll = () => {
                const target = document.getElementById('bannerSearch');
                if (target) {
                    const rect = target.getBoundingClientRect();
                    const isInView = rect.top < window.innerHeight && rect.bottom >= 0;
                    setShowSearchBar(!isInView);
                } else {
                    setShowSearchBar(false);
                }
            };

            throttledHandleScroll = throttle(handleScroll, 200);
            window.addEventListener('scroll', throttledHandleScroll);
            handleScroll(); // 初始检查

            // 检查元素是否延迟加载
            checkElementExist = setInterval(() => {
                const target = document.getElementById('bannerSearch');
                if (target) {
                    clearInterval(checkElementExist);
                    handleScroll();
                }
            }, 100);

        } else {
            setShowSearchBar(true);
        }


        return () => {
            if (throttledHandleScroll) {
                window.removeEventListener('scroll', throttledHandleScroll);
            }
            if (checkElementExist) {
                clearInterval(checkElementExist);
            }
        };
    }, [pathname]);

    return (
        <header className="page_header">
            <div className='page_header_bx'>
                <Flex align='center' justify='space-between'>
                    <Logo />
                    {showSearchBar && <SearchBar />}
                    <HeaderBar />
                </Flex>
                <TopNav />
            </div>
        </header>
    );
}